module.exports = __webpack_public_path__ + "img/missionaries22_2019_7-7-2021.c3619e0a.jpg";